import { devtoolsExchange } from '@urql/devtools'
import { createClient, dedupExchange, cacheExchange, fetchExchange, ssrExchange } from 'urql'

import { traceExchange, errorExchange } from '../server/helpers/custom-exchanges'
import { env, isDev } from '../server/helpers/env'

import { graphql } from '~/../__config__/urls.json'

const makeClient = ({ isServer, fetch, trace, ctx }) => {
  const isClient = !isServer
  const serverURL = graphql[isServer ? 'server' : 'client'][env]

  if (isDev) {
    console.log(`Creating urql client - URL: ${serverURL}`)
  }

  // Phase 1: ready the exchanges to pass them through to the clients.
  const ssrCache = ssrExchange({
    initialState: isClient ? window.__initialState__ : null,
    isClient
  })

  const exchanges = isServer
    ? [dedupExchange, traceExchange(trace), ssrCache]
    : [dedupExchange, cacheExchange, ssrCache]

  exchanges.push(errorExchange)
  exchanges.push(fetchExchange)

  // Phase 2: create the fetch options that will be passed to every request.
  const fetchOptions = { credentials: 'same-origin' }

  if (isServer) {
    // Forward Fastly headers to graphql from the server
    fetchOptions.headers = {
      'X-Uscd': ctx.get('X-Uscd'),
      'X-Is-Server': 'true'
    }
    const addCookieToFetchOptions = (newCookie) => {
      fetchOptions.headers.cookie = fetchOptions.headers.cookie
        ? `${fetchOptions.headers.cookie} ${newCookie};`
        : `${newCookie};`
    }
    // Forward client cookies to graphql from the server
    if (ctx.userId) {
      addCookieToFetchOptions(`uscd=${ctx.userId}`)
    }
  }

  // In development, set the uscd header. This allows comparison running locally
  // to use the staging instance of broadband-aggregator.
  if (!isServer && isDev) {
    fetchOptions.headers = {
      uscd: process.env.RAZZLE_DEV_USCD
    }
  }

  // Phase 3: create client
  const client = createClient({
    url: serverURL,
    suspense: isServer,
    fetch,
    fetchOptions,
    requestPolicy: 'cache-first',
    exchanges: isDev ? [devtoolsExchange, ...exchanges] : exchanges
  })

  return [client, ssrCache]
}

export default makeClient
